angular
    .module('quattro.bmbo.email.form', [
        'quattro.core.user.sessionstorage',
        'quattro.core.hpls-api-validation',
        'quattro.core.password-form',
        'quattro.core.alias.form',
        'quattro.core.forward.form',
        'quattro.core.user.service',
        'quattro.core.viewhelper',
        'quattro.bmbo.config',
    ])
    .directive('bmboEmailForm', function () {
        return {
            restrict: 'E',
            scope: {
                data: '=data',
                isCreate: '=?',
                cancel: '=',
                // will be called after successfull validation
                save: '=',
            },
            controller: 'bmboEmailFormController',
            controllerAs: 'vm',
            templateUrl: 'bmbo/email/email-form.html',
        };
    })
    .controller('bmboEmailFormController', function ($scope, userService, mail_plan_list, mail_plan_list_new_pricing_add_quota, viewHelper, api, $translate) {

        this.user = userService.scope;
        this.defaultLanguage = $translate.use();
        $scope.data.defaultLanguage = $translate.use();

        function handleResult(result) {
            $scope.data.plansavailable = result.plansavailable;
        }

        function handleError(error) {
            $log.error('domain.get failed! code: ' + error.code + ' - message: ' + error.message);
        }

        if ($scope.isCreate) {
            api.single('domain.get', {'domain': $scope.data.domain})
                .then(handleResult, handleError);
        }

        this.mail_plan_list = mail_plan_list;
        this.mail_plan_list_new_pricing_add_quota = mail_plan_list_new_pricing_add_quota;
        this.forward_form = {};
        this.alias_form = {};

        this.validateForward = function (value) {
            return $scope.data.$validate('forwards', [value]);
        };

        this.validateAlias = function (value) {
            return $scope.data.$validate('aliases', [value]);
        };


        this.save = function () {
            if (!$scope.data.language) {
                $scope.data.language = $scope.data.defaultLanguage;
            }
            if (angular.isFunction(this.forward_form.flush)) {
                this.forward_form.flush();
            }

            if (angular.isFunction(this.alias_form.flush)) {
                this.alias_form.flush();
            }

            if (viewHelper.formIsValid()) {
                $scope.save();
            }
        };
    });
